
// on choose fibre plan page load.
export const tagOnSOPageLoad = () => {
  window.MyTIQ.view({
    page_event: "view",
    service_application_event: "start",
    service_application_name: "myvodacom: my fibre: tracking sales order (transaction)",
    service_application_step: "myvodacom: my fibre: tracking sales order: enter details",
    service_application_type: "transaction",
    page_name: "myvodacom: my fibre: tracking sales order: enter details"
  });
}

export const tagOnSODetailsPageLoad = () => {
  window.MyTIQ.view({
    page_event: "view",
    service_application_event: "finish",
    service_application_name: "myvodacom: my fibre: tracking sales order (transaction)",
    service_application_step: "myvodacom: my fibre: tracking sales order: success",
    service_application_type: "transaction",
    page_name: "myvodacom: my fibre: tracking sales order: success"
  });
}

export const tagOnSODetailsPageErrorLoad = () => {
  window.MyTIQ.view({
    page_event: "view",
    service_application_event: "finish",
    service_application_name: "myvodacom: my fibre: tracking sales order (transaction)",
    service_application_step: "myvodacom: my fibre: tracking sales order: not found",
    service_application_type: "transaction",
    page_name: "myvodacom: my fibre: tracking sales order: not found"
  });
}

export const tagOnSOTechnicalError = () => {
  window.MyTIQ.view({
    page_form_event: "error",
    page_errors: "[capture error message on screen]",
    page_name: "myvodacom: my fibre: tracking sales order journey"
  });
}